<template>
  <div v-show="auth.user.role == 'ADMIN'">
    <Head title="Create User" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/users">Users</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />
          <select-input class="pb-8 pr-6 w-full lg:w-1/2" label="Role" @change="form.role = $event.target.value;">
            <option v-for="UserRole in UserRoles" v-bind:value="form.role">
              {{UserRole.toUpperCase()}}
            </option>
          </select-input>
          <text-input v-model="form.role" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-1/2 hide" label="Role"></text-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
          <div class="w-full">Vendor:<br/><br/>
            <SelectInput  id="vendor" class="mb-4 w-full" v-model="form.vendor" :error="form.errors.vendor" >
              <option value="0">None (CarbonMark)</option>
              <option v-for="vendor in this.vendors.data" :value="vendor.id"> {{ vendor.vendorname }}</option>
            </SelectInput>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create User</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import {
  UserRoles,
} from "./../../../enums";

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        role: null,
        photo: null,
        vendor: null,
      }),
      UserRoles,
    }
  },
  methods: {
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    store() {
      this.form.post('/users')
    },
  },
  props: {
    auth: Object,
    vendors: Object,
  },
}
</script>
